<template>
  <main class="app-content">
    <div class="app-title">
      <div><h1><font-awesome-icon icon="chart-pie" /> Báo cáo đối tác</h1></div>
    </div>

    <!-- Non-agency: chọn đối tác để xem -->
    <div class="tile mb-2" v-if="!isAgency">
      <div class="form-inline">
        <label class="mr-2">Đối tác:</label>
        <admin-user-select style="min-width:260px" :model="ctx" attribute="agency" roleFilter="agency"
                           place-holder="Chọn tài khoản đối tác" @input="onAgencyChange"></admin-user-select>
      </div>
    </div>

    <div v-if="agencyId">
      <ul class="nav nav-tabs">
        <li class="nav-item" v-for="t in tabs" :key="t.value">
          <a class="nav-link" href="#" :class="{ active: tab === t.value }" @click.prevent="switchTab(t.value)">{{ t.label }}</a>
        </li>
      </ul>

      <!-- TAB Khách hàng -->
      <div class="tile" v-if="tab === 'client'">
        <div class="row text-center mb-3">
          <div class="col"><div class="h4 mb-0">{{ clientSummary.total }}</div><small class="text-muted">Tổng khách</small></div>
          <div class="col"><div class="h4 mb-0 text-success">{{ clientSummary.active }}</div><small class="text-muted">Đang hoạt động</small></div>
          <div class="col"><div class="h4 mb-0 text-warning">{{ clientSummary.trial }}</div><small class="text-muted">Dùng thử</small></div>
          <div class="col"><div class="h4 mb-0 text-danger">{{ clientSummary.expired }}</div><small class="text-muted">Hết hạn</small></div>
        </div>
        <div class="form-inline mb-2">
          <input v-model="clientKeyword" class="form-control mr-1" placeholder="Tìm tên / domain" @keyup.enter="loadClient(1)" />
          <button class="btn btn-primary" @click="loadClient(1)">Tìm</button>
        </div>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead><tr><th>Khách hàng</th><th class="text-right">Số dư</th><th class="text-right">Hạn mức</th><th>Trạng thái</th><th>Hết hạn</th></tr></thead>
            <tbody>
              <tr v-if="!clientDocs.length"><td colspan="5" class="text-center text-muted py-3">Không có dữ liệu</td></tr>
              <tr v-for="c in clientDocs" :key="c._id">
                <td><b>{{ c.companyName || c.domain }}</b><div class="small text-muted">{{ c.domain }}</div></td>
                <td class="text-right" :class="c.creditBalance < 0 ? 'text-danger' : ''">{{ fmt(c.creditBalance) }}</td>
                <td class="text-right">{{ fmt(c.creditLimit) }}</td>
                <td><span class="badge" :class="c.isTrial ? 'badge-warning' : (c.active ? 'badge-success' : 'badge-secondary')">{{ c.isTrial ? 'Dùng thử' : (c.active ? 'Hoạt động' : 'Ngưng') }}</span></td>
                <td class="small">{{ c.expireTime ? formatDate(c.expireTime) : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- TAB Đơn gói dịch vụ -->
      <div class="tile" v-if="tab === 'plan'">
        <div class="row text-center mb-3">
          <div class="col"><div class="h4 mb-0">{{ planSummary.count }}</div><small class="text-muted">Số đơn</small></div>
          <div class="col"><div class="h4 mb-0 text-primary">{{ fmt(planSummary.total) }}đ</div><small class="text-muted">Tổng giá trị</small></div>
          <div class="col"><div class="h4 mb-0 text-success">{{ fmt(planSummary.commission) }}đ</div><small class="text-muted">Hoa hồng đối tác</small></div>
        </div>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead><tr><th>Khách hàng</th><th>Loại</th><th>Gói</th><th class="text-right">Giá trị</th><th class="text-right">Hoa hồng</th><th>Ngày</th></tr></thead>
            <tbody>
              <tr v-if="!planDocs.length"><td colspan="6" class="text-center text-muted py-3">Không có đơn nào</td></tr>
              <tr v-for="o in planDocs" :key="o._id">
                <td>{{ o.client ? (o.client.companyName || o.client.domain) : '-' }}</td>
                <td><span class="badge badge-info">{{ planType(o.type) }}</span></td>
                <td>{{ o.plan ? o.plan.name : '-' }}</td>
                <td class="text-right">{{ fmt(o.total) }}</td>
                <td class="text-right text-success">{{ fmt(o.agencyCommission) }}</td>
                <td class="small">{{ formatDate(o.createTime) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- TAB Tài chính + đối soát công nợ -->
      <div class="tile" v-if="tab === 'finance'">
        <div class="row mb-3">
          <div class="col-md-3"><div class="card text-center p-2"><div class="h5 mb-0">{{ finance.summary.clientCount }}</div><small class="text-muted">Khách</small></div></div>
          <div class="col-md-3"><div class="card text-center p-2"><div class="h5 mb-0" :class="finance.summary.totalBalance < 0 ? 'text-danger' : ''">{{ fmt(finance.summary.totalBalance) }}đ</div><small class="text-muted">Tổng số dư</small></div></div>
          <div class="col-md-3"><div class="card text-center p-2"><div class="h5 mb-0">{{ fmt(finance.summary.totalLimit) }}đ</div><small class="text-muted">Tổng hạn mức</small></div></div>
          <div class="col-md-3"><div class="card text-center p-2"><div class="h5 mb-0 text-danger">{{ fmt(finance.summary.totalDebt) }}đ</div><small class="text-muted">Công nợ (đang dùng)</small></div></div>
        </div>
        <div class="alert alert-info">
          <font-awesome-icon icon="hand-holding-usd" /> Tổng hạn mức đối tác đã được duyệt cấp:
          <b>{{ fmt(finance.summary.granted) }}đ</b> ({{ finance.summary.grantedCount }} lệnh)
          — Công nợ khách đang dùng: <b class="text-danger">{{ fmt(finance.summary.totalDebt) }}đ</b>
        </div>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead><tr><th>Khách hàng</th><th class="text-right">Số dư</th><th class="text-right">Hạn mức</th><th class="text-right">Đang nợ</th></tr></thead>
            <tbody>
              <tr v-if="!finance.clients.length"><td colspan="4" class="text-center text-muted py-3">Không có dữ liệu</td></tr>
              <tr v-for="c in finance.clients" :key="c._id">
                <td><b>{{ c.companyName || c.domain }}</b></td>
                <td class="text-right" :class="c.creditBalance < 0 ? 'text-danger' : ''">{{ fmt(c.creditBalance) }}</td>
                <td class="text-right">{{ fmt(c.creditLimit) }}</td>
                <td class="text-right text-danger">{{ c.debt > 0 ? fmt(c.debt) : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else-if="!isAgency" class="text-center text-muted py-4">Chọn đối tác để xem báo cáo</div>
  </main>
</template>

<script>
import moment from 'moment';
import AdminUserSelect from '@/components/AdminUserSelect';

export default {
  components: { AdminUserSelect },
  data() {
    return {
      ctx: { agency: null },
      tab: 'client',
      tabs: [
        { value: 'client', label: 'Khách hàng' },
        { value: 'plan', label: 'Đơn gói dịch vụ' },
        { value: 'finance', label: 'Tài chính' },
      ],
      clientKeyword: '',
      clientDocs: [], clientSummary: { total: 0, active: 0, trial: 0, expired: 0 },
      planDocs: [], planSummary: { total: 0, commission: 0, count: 0 },
      finance: { summary: { clientCount: 0, totalBalance: 0, totalLimit: 0, totalDebt: 0, granted: 0, grantedCount: 0 }, clients: [] },
    };
  },
  computed: {
    role() { return this.$store.state.user.role; },
    isAgency() { return this.role === 'agency'; },
    agencyId() { return this.isAgency ? this.$store.state.user._id : this.ctx.agency; },
    params() { return this.isAgency ? {} : { agency: this.ctx.agency }; },
  },
  methods: {
    fmt(n) { return (n != null) ? Number(n).toLocaleString('vi-VN') : '0'; },
    formatDate(t) { return t ? moment(t).format('DD/MM/YYYY') : '-'; },
    planType(t) { return { new: 'Mua mới', upgrade: 'Nâng cấp', extend: 'Gia hạn', user: 'Thêm user', setup: 'Cài đặt', newDivide: 'Tách domain', unlimited: 'Không giới hạn', promo: 'Khuyến mại' }[t] || t; },
    onAgencyChange() { if (this.agencyId) this.loadTab(); },
    switchTab(t) { this.tab = t; this.loadTab(); },
    loadTab() {
      if (!this.agencyId) return;
      if (this.tab === 'client') this.loadClient(1);
      else if (this.tab === 'plan') this.loadPlan(1);
      else if (this.tab === 'finance') this.loadFinance();
    },
    loadClient(page) {
      const loader = this.$loading.show();
      this.$service.get('/agency-report/client', { params: { ...this.params, page: page || 1, pageSize: 50, keyword: this.clientKeyword } })
        .then(r => { this.clientDocs = r.data.docs || []; this.clientSummary = r.data.summary || this.clientSummary; })
        .catch(this.err).finally(() => loader.hide());
    },
    loadPlan(page) {
      const loader = this.$loading.show();
      this.$service.get('/agency-report/plan-order', { params: { ...this.params, page: page || 1, pageSize: 50 } })
        .then(r => { this.planDocs = r.data.docs || []; this.planSummary = r.data.summary || this.planSummary; })
        .catch(this.err).finally(() => loader.hide());
    },
    loadFinance() {
      const loader = this.$loading.show();
      this.$service.get('/agency-report/finance', { params: this.params })
        .then(r => { this.finance = r.data || this.finance; })
        .catch(this.err).finally(() => loader.hide());
    },
    err(error) {
      const msg = error.response && error.response.data && (error.response.data.message || error.response.data.msg);
      this.$swal({ text: msg || 'Có lỗi xảy ra', icon: 'error' });
    },
  },
  mounted() {
    if (this.isAgency) this.loadTab();
  },
};
</script>
